import { StyleUtil } from 'utils/StyleUtil'
import closeSvg from '../images/close2.svg'
import tickLargeSvg from '../images/tick-large.svg'
import warningSvg from '../images/warning.svg'
import LargeSpinner from './LargeSpinner'

export enum MessageType {
  Generating = 'Generating',
  Completed = 'Completed',
  CompletedPartially = 'CompletedPartially',
}

interface Props {
  messageType: MessageType
  data: any
  onClose: () => void
}

export default function WidgetQuizGenerator({
  messageType,
  data,
  onClose,
}: Props): JSX.Element {
  return (
    <div
      className="absolute z-[999] flex h-full w-full flex-col items-center justify-center bg-[#D5D5DBAA]"
      data-testid="widget-quiz-generator"
    >
      <div className="flex max-h-[50%] w-[572px] flex-col gap-[12px] bg-white p-[24px] shadow-xl">
        <img
          src={closeSvg}
          className="cursor-pointer self-end"
          alt="close"
          data-testid="btn-close-quiz-generator"
          onClick={onClose}
        />
        {messageType === MessageType.Generating && (
          <LargeSpinner text="Generating questions..." />
        )}
        {messageType === MessageType.Completed && (
          <div className="flex w-full flex-col items-center justify-center gap-[36px] text-center">
            <div>
              <p
                className="text-[20px] font-bold text-purple"
                data-testid="text-questions-generated"
              >
                Questions generated
              </p>
              <p className="text-[20px] font-bold text-[#000]">
                You now have a draft quiz to review and edit - do not finalise
                or send for review without editing first!
              </p>
            </div>
            <img src={tickLargeSvg} alt="tick" />
            <button
              className={StyleUtil.buttonPrimaryUnsw}
              onClick={onClose}
              data-testid="btn-ok-questions-generated"
            >
              Ok
            </button>
          </div>
        )}
        {messageType === MessageType.CompletedPartially && (
          <div className="flex w-full flex-col items-center justify-center gap-[24px] pb-[12px] text-center">
            <p className="text-[20px] font-bold text-purple">
              Questions generated
            </p>
            <p className="flex flex-wrap items-center gap-1 text-[18px] font-bold text-[#000]">
              <img src={warningSvg} alt="warning" />
              Not enough topics selected to generate all{' '}
              <span className="text-redHighlight">{data?.total}</span> questions
            </p>
            <button
              className={StyleUtil.buttonPrimaryUnsw}
              onClick={onClose}
              data-testid="btn-ok-partially-generated"
            >
              Ok
            </button>
          </div>
        )}
      </div>
    </div>
  )
}
